<template>
  <div>
    <b-container class='mt-4'>
      <b-row class='mt-4'>
        <b-col cols='7' class='mx-auto mt-4'>
          <validation-observer class="form bg-white" ref="obs" >
            <div class="row mt-3 ">
              <div class="col-12 mx-auto">
                <label ><span class="text-danger">*</span>{{$t("message.mail_adress")}}</label>
                <validation-provider name="email" rules="required|email">
                  <div slot-scope="mail_adress">
                    <input class="dirty b-w-0 p-2 bg-gray width100" v-model="email" placeholder="ex）example@aelu.com" >
                    <p v-if="mail_adress.failed" class="error">{{ mail_adress.errors[0] }}</p>
                  </div>
                </validation-provider>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 mx-auto">
                <label ><span class="text-danger">*</span>{{$t("message.password")}}</label>
                <validation-provider name="password" rules="required|password">
                  <div slot-scope="passwordScope"> 
                    <input :type="inputType" class="dirty b-w-0 p-2 bg-gray width100" v-model="password" placeholder="ex）1234!Abcd">
                    <span class="field-icon" @click="switchPassword">
                      <font-awesome-icon fas :icon="icon" />
                    </span>
                    <p v-if="passwordScope.failed" class="error">{{ passwordScope.errors[0] }}</p>
                  </div>
                </validation-provider>
                <label class="text-gray">{{$t("message.pass_condition")}}</label>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 mx-auto">
                <label ><span class="text-danger">*</span>{{$t("message.password_confirm")}}</label>
                <validation-provider name="password_confirm" rules="required|confirmed:password">
                  <div slot-scope="passwordConfirmScope"> 
                    <input :type="inputTypeConfirm" class="dirty b-w-0 p-2 bg-gray width100" v-model="password_confirm" placeholder="ex）1234!Abcd">
                    <span class="field-icon" @click="switchPasswordConfirm">
                      <font-awesome-icon fas :icon="iconConfirm" />
                    </span>
                    <p v-if="passwordConfirmScope.failed" class="error">{{ passwordConfirmScope.errors[0] }}</p>
                  </div>
                </validation-provider>
                <label class="text-gray" >{{$t("message.pass_condition")}}</label>
              </div>
            </div>

            <div class="row mt-3 mb-4">
              <div class="col-12 mx-auto text-center">
                <p class="font13" style="display: inline;">{{$t("message.agreement1")}}</p>
                <b-button  class="sign_up px-0" style="display: inline;">
                  <u>{{$t("message.terms")}}</u>
                </b-button>
                <p class="font13" style="display: inline;">{{$t("message.agreement2")}}</p>
                <b-button  class="login mt-3 py-2 px-4 width100" @click="signup" > {{$t("message.agree")}} </b-button>
              </div>

              <div class="col-12 mt-3 mx-auto text-center ">
                <p class="font13 mb-0" style="display: inline;">{{$t("message.have_account")}}</p>
                <router-link to="signup">
                  <b-button  class="sign_up px-0">
                    <u>{{$t("message.login")}}</u>
                  </b-button>
                </router-link>
              </div>
            </div>
          </validation-observer>
        </b-col>
      </b-row>
    </b-container>
    <confirm-modal ref="confirmModal" :email="email" mode='org'></confirm-modal>
  </div>
</template>
<script>
import ConfirmModal from "@/components/User/Session/ConfirmModal";
import {Auth} from 'aws-amplify';
export default {
  components: {
    ConfirmModal
  },
  data() {
    return {
      signupModal: false,
      email: '',
      password: '',
      password_confirm: '',
      inputType: 'password',
      inputTypeConfirm: 'password',
      isChecked: true,
      isCheckedConfirm: true,
      icon: "eye",
      iconConfirm: "eye"
    }
  },
  methods: {
    signup(){
      this.$refs.obs.validate().then(value =>{
        if(value){
          Auth.signUp({username: this.email, password: this.password, attributes: {email: this.email}})
            .then(() =>{
              this.$refs.confirmModal.showModal()
            })
            .catch(error =>{
              console.log('thsi is errors',error)
            })
          }
        })
    },
    switchPassword(){
      if (this.isChecked) {
        this.isChecked = false
        this.inputType = "text"
        this.icon = "eye-slash"
      } else {
        this.isChecked = true
        this.inputType = "password"
        this.icon = "eye"
      }
    },
    switchPasswordConfirm(){
      if (this.isCheckedConfirm) {
        this.isCheckedConfirm = false
        this.inputTypeConfirm = "text"
        this.iconConfirm = "eye-slash"
      } else {
        this.isCheckedConfirm = true
        this.inputTypeConfirm = "password"
        this.iconConfirm = "eye"
      }
    },
  },
  mounted(){
    console.log(this.AUTHMODE)
    this.$store.commit('setLoading', false)
  }
}
</script>
<style scoped lang="scss"> 
.sign_up{
  background: #FFFFFF !important;
  color: #F29147 !important;
  border-color: #FFFFFF !important;
  font-size: 14px;

  &:hover {
    box-shadow: none !important;
  }
}


</style>
